var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed z-[9999] inset-0 pointer-events-none"},[_c('canvas',{ref:"canvas",staticClass:"block w-full h-full !text-xl",style:({ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' })})])}
var staticRenderFns = []

export { render, staticRenderFns }